/**
 * 약관 전문 (/m/setting/terms?t=1|2) — 공용 형제탭(#sub-tab-nav)을 채워 같은 화면 안에서 약관을 바꿔 본다
 * ($j.Pages.Mobile.SettingTerms / body data-page-name="SettingTerms")
 */
export default class SettingTerms {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        $(function () {
            const LABELS = D.labels;
            const $bar = $('#sub-tab-nav');

            $bar.find('ul').html(LABELS.map((label, i) =>
                `<li><a href="javascript:void(0)" class="${i ? '' : 'on'}" data-idx="${i}">${label}</a></li>`
            ).join(''));
            $bar.prop('hidden', false);
            document.body.classList.add('has-subtab');   // 본문을 탭바 높이만큼 내린다 (_subtab.scss)

            $bar.on('click', 'a', function () {
                const idx = String($(this).data('idx'));
                $bar.find('a').removeClass('on');
                $(this).addClass('on');
                $('.terms-page__body').each(function () {
                    $(this).prop('hidden', String($(this).data('idx')) !== idx);
                });
                window.scrollTo(0, 0);
            });
        });

    }
}
